/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';

import PropTypes from 'prop-types';

import './Pagination.less';

const MAX_BULLETS = 12;

function Pagination({onClick, total, current, id}) {
  const listItems = [];
  if (total < MAX_BULLETS) {
    for (let i = 1; i <= total; i++) {
      if (i === current)
        listItems.push(
          <li key={i}>
            <a
              className="active"
              onClick={onClick}
              id={i}
            />
          </li>,
        );
      else
        listItems.push(
          <li key={i}>
            <a
              onClick={onClick}
              id={i}
            />
          </li>,
        );
    }
    return (
      <div className="pagging center">
        <ol
          id="pagination"
          className=""
        >
          {listItems}
        </ol>
      </div>
    );
  }
  return (
    <div
      className=" pagging pagination-text"
      id={id}
    >
      <div className="pagination-text-position">
        <span className="center textPaginationView">{current}</span>
        <br />
        <span className="center">Of</span>
        <br />
        <span className="center textPaginationView">{total}</span>
      </div>
    </div>
  );
}

Pagination.propTypes = {
  onClick: PropTypes.func,
  total: PropTypes.number,
  current: PropTypes.number,
  id: PropTypes.string,
};

Pagination.defaultProps = {
  onClick: () => {},

  total: 0,
  current: 0,
  id: '',
};

export default Pagination;
